<!-- <div *ngIf="!regflag" id="bg" class="c page-content fade-in-up">
  <br><br>
  <br>
  <br>
  <div class="login-form2">
    <div class="row">
      <div class="col-12"
        style="text-align:center;font-size:xx-large;font-weight: 700;text-decoration: underline;margin-top: 20px;color:rgb(5, 5, 128)">
        Your Identity</div>
    </div>
    <br>
    <div class="row">
      <div class="col-12 text-center">
        <div class="msger-inputarea">
          <input id="input1" type="text" [(ngModel)]="loginid" placeholder="Enter Email / Phone No."
            *ngIf="phoneFlag && emailFlag">
          <input id="input1" type="number" [(ngModel)]="loginid" placeholder="Enter Phone No."
            *ngIf="phoneFlag && !emailFlag">
          <input id="input1" type="email" [(ngModel)]="loginid" placeholder="Enter Email"
            *ngIf="!phoneFlag && emailFlag">
          <button id="input2" class="btn btn-outline-primary" (click)="getCurrentLegalEntitybyid()">Search</button>
          <button id="input2" class="btn btn-outline-danger" (click)="cancel()">Cancel</button>
        </div>

      </div>
    </div>
    <div *ngIf="detail" class="row" style="margin-top:20px ;">
      <div class="col-2"></div>
      <div class="col-4 text-left">
        <h6> PARTY NAME</h6>
      </div>
      <div class="col-4 text-right"><input type="text" class="form-control" placeholder="enter party name"
          [(ngModel)]="legaldata['party_name']" required></div>
      <div class="col-2"></div>
    </div>
    <br>

    <div *ngIf="detail" class="row">
      <div class="col-2"></div>
      <div class="col-4 text-left">
        <h6>USER EMAIL ID : </h6>
      </div>

      <div class="col-4 text-right"> <input type="text" class="form-control" placeholder="enter email"
          [(ngModel)]="legaldata['contact_email']" required>
      </div>

      <div class="col-2"></div>
    </div>
    <br>

    <div *ngIf="detail" class="row">
      <div class="col-2"></div>
      <div class="col-4 text-left">
        <h6>USER MOBILE NO.</h6>
      </div>

      <div class="col-4 text-right"><input type="number" class="form-control" placeholder="enter mobile number"
          [(ngModel)]="legaldata['phone_no']" required></div>

      <div class="col-2"></div>
    </div>

    <br>
    <div *ngIf="detail" class="row">
      <div class="col-12 text-center">
        <button id="button" class="btn btn-outline-success" (click)="loginFinal()">Login</button>
      </div>
    </div>

  </div>
</div>
<div *ngIf="regflag" id="bg" class="c page-content fade-in-up">
  <br><br>
  <div class="login-form2">
    <div class="row">

      <div class="col-12 text-center">
        <br>
        <img src="../../assets/img/regis.png">

      </div>
    </div>
    <div *ngIf="emailRegFlag || phoneFlag">
      <br>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-4 text-left">
          <h6>ENTER PARTY NAME<span class="required">*</span>:</h6>
        </div>
        <div class="col-4 text-right"><input type="text" class="form-control" placeholder="enter party name"
            [(ngModel)]="Obj['party_name']" required></div>
        <div class="col-2"></div>
      </div>
      <br>
      <div *ngIf="emailRegFlag">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-4 text-left">
            <h6>ENTER EMAIL ID <span class="required">*</span>: </h6>
          </div>

          <div class="col-4 text-right"> <input type="text" class="form-control" placeholder="enter email"
              [(ngModel)]="Obj['email']" required *ngIf="!dataflag">
            <input type="text" class="form-control" placeholder="enter email" [(ngModel)]="Obj['email']" required
              disabled *ngIf="dataflag">
          </div>
          <div class="col-2"></div>

        </div>
        <br>
      </div>


      <div *ngIf="phoneFlag">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-4 text-left">
            <h6>ENTER MOBILE NO.<span class="required">*</span> :</h6>
          </div>

          <div class="col-4 text-right"><input type="number" class="form-control" placeholder="enter mobile number"
              [(ngModel)]="Obj['phone_no']" required *ngIf="!dataflag">
            <input type="number" class="form-control" placeholder="enter mobile number" [(ngModel)]="Obj['phone_no']"
              required *ngIf="dataflag" disabled></div>

          <div class="col-2"></div>
          <br>
        </div>
        <br>
      </div>
      <br>
      <div *ngIf="orgAllowed">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-4 text-left">
            <h6>PARTY TYPE <span class="required">*</span>:</h6>
          </div>

          <div class="col-4 text-right">
            <ng-select [items]="nation" bindLabel="id" bindValue="value" placeholder="select party type"
              [(ngModel)]="Obj['nationality']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
              name="work_order_id" required>
            </ng-select>
          </div>
          <div class="col-2"></div>
        </div>
        <br>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <button (click)="regitser()" class="btn  btn-blue1">Submit</button>&nbsp;&nbsp;
        </div>
      </div>
      <br>
    </div>
    <div class="row" style="color: darkblue;" *ngIf="goaFlag && (emailRegFlag || phoneFlag)">
      <div class="col-5">
        <hr class="hr1">
      </div>
      <div class="col-2 text-center">
        <h4>
          OR</h4>
      </div>
      <div class="col-5">
        <hr class="hr1">
      </div>

    </div>
    <br>
    <div class="row" *ngIf="goaFlag">
      <br>

      <div class="col-12 text-center">
        <h6>
          <div id="signin_button"></div>
        </h6>
      </div>
    </div>
    <br>
  </div>
</div>


<div class="modal" id="myModalregverify">
  <div class="modal-dialog" style="max-width: 80%;">
    <div class="modal-content">


      <div class="modal-header">
        <h5 class="modal-title" style="font: bold; color: rgb(23, 157, 157);">Verify Details :</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>


      <div class="modal-body">
        <div id="boxBLUE">
          <div style="margin-left: 5%;margin-right: 5%;">
            <div class="mt-12 mb-12">
              <p class="text-center text-black font-mono text-lg font-bold mt-6"
                style="color: #a33a41;font-weight:bold;">Please Verify your details before Registration</p>


            </div>
            <br>
            <div class="row">
              <div class="col-2"></div>
              <div class="col-4 text-left">
                <h6>ENTER PARTY NAME<span class="required">*</span>:</h6>
              </div>
              <div class="col-4 text-right"><input type="text" class="form-control" placeholder="enter party name"
                  disabled [(ngModel)]="Obj['party_name']" required></div>
              <div class="col-2"></div>
            </div>
            <br>
            <div *ngIf="emailRegFlag">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-4 text-left">
                  <h6>ENTER EMAIL ID <span class="required">*</span>: </h6>
                </div>

                <div class="col-4 text-right"> <input type="text" class="form-control" placeholder="enter email"
                    [(ngModel)]="Obj['email']" required disabled>

                </div>
                <div class="col-2"></div>

              </div>
              <br>
            </div>
            <div *ngIf="phoneFlag">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-4 text-left">
                  <h6>ENTER MOBILE NO.<span class="required">*</span> :</h6>
                </div>

                <div class="col-4 text-right">
                  <input type="number" class="form-control" placeholder="enter mobile number"
                    [(ngModel)]="Obj['phone_no']" required disabled>
                </div>

                <div class="col-2"></div>
                <br>
              </div>
              <br>
            </div>
            <br>
            <div *ngIf="orgAllowed">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-4 text-left">
                  <h6>PARTY TYPE <span class="required">*</span>:</h6>
                </div>

                <div class="col-4 text-right">
                  <ng-select [items]="nation" bindLabel="id" bindValue="value" placeholder="select party type"
                    [(ngModel)]="Obj['nationality']" [selectableGroupAsModel]="false" [closeOnSelect]="true" disabled
                    name="work_order_id" required>
                  </ng-select>
                </div>
                <div class="col-2"></div>
              </div>
              <br>
            </div>
          </div>
        </div>
        <br>


        <div class="modal-footer">
          <button (click)="finalregister()" class="btn btn-blue1">Register</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="close()">Close</button>
        </div>

      </div>
    </div>
  </div>
</div> -->

<div class="loginback">
  <div class="Parent"> 
    <div class="child1"> 
    
    </div> 
    <div class="child2"> 
      <h1>Sign Up</h1>
   
      <div class="welcome-back">
        Welcome to Svayam <i class="fa fa-smile"></i>
      </div>
      <br>
      <div class="row" *ngIf="emailRegFlag || phoneFlag">
        <div class="col-2"></div>
        <div class="col-8">
          <div class="form-group">
            <input type="text" name="mobile_number" placeholder="Enter Party Name *" 
              class="form-control" [(ngModel)]="Obj['party_name']"  />
        
            <i class="input-icon fa fa-pencil"></i>
          </div>
        </div>
        </div>
        <div class="row"  *ngIf="emailRegFlag">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-group">
              <input type="text" name="mobile_number" placeholder="Enter Email Id *" 
                class="form-control" [(ngModel)]="Obj['email']"  />
          
              <i class="input-icon fa fa-pencil"></i>
            </div>
          </div>
          </div>
          <div class="row" *ngIf="phoneFlag">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="form-group">
                <input type="number" name="mobile_number" placeholder="Enter Mobile No. *" 
                  class="form-control"   [(ngModel)]="Obj['phone_no']"/>
            
                <i class="input-icon fa fa-pencil"></i>
              </div>
            </div>
            </div>
            <div class="row" *ngIf="orgAllowed">
              <div class="col-2"></div>
              <div class="col-8">
                <div class="form-group">
                  <ng-select [items]="nation" class="select" bindLabel="id" bindValue="value" placeholder="select party type"
                  [(ngModel)]="Obj['nationality']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                  name="work_order_id" required style="color:rgba(94, 94, 226, 0.595)!important;font-size: smaller;border: 1px solid white;">
                </ng-select>
              
                
                </div>
              </div>
              </div>

            <div class="row">
              <div class="col-12 text-center">
                  <button class="btn btn-info btn-block loginbtn" type="submit" (click)="finalregister()"><i class="fa fa-lock"></i> Sign Up </button>
                  
                  <!-- <button class="btn btn-info btn-block" type="submit" (click)="cancel()">Cancel</button> -->
              </div>
          </div>
          <div class="row" style="color: darkblue;" *ngIf="goaFlag && (emailRegFlag || phoneFlag)">
            <div class="col-12 text-center">
  
              <h6>
              or
              </h6>
              </div>
      
          </div>
       
 
      <!-- <div class="or-text">Or login using:</div> -->
      
      <div class="row" *ngIf="goaFlag">
        <br>
  
        <div class="col-12 text-center">
          <h6>
            <div id="signin_button"></div>
          </h6>
        </div>
      </div>
      
      <p style="text-align:center ;" class="textsign">Already Signed up? <a class="signup-link" (click)="gotoLogin()">Log In</a></p>
    </div> 
  </div> 
  </div>
